import { type RentCell } from '@rentguru/commons-utils';
import { type ReactNode } from 'react';

import { type ButtonVariant } from '@ui/components/base/button';

type RentDensity = 'comfortable' | 'compact';
type RentCellChange = 'down' | 'status' | 'up';
type RentAriaSort = 'ascending' | 'descending' | 'none';

enum RentMatrixVariant {
  FIT = 'fit',
  SCROLL = 'scroll',
}

enum RentCellTone {
  CALLED_NOT_DUE = 'CALLED_NOT_DUE',
  COVERED = 'COVERED',
  EMPTY = 'EMPTY',
  FORECAST = 'FORECAST',
  LATE = 'LATE',
  NONE = 'NONE',
  PAID = 'PAID',
  PARTIAL = 'PARTIAL',
  VACANT = 'VACANT',
}

type RentMatrixCell = Pick<RentCell, 'coveredDueDate' | 'coveredStatus' | 'due' | 'forecast' | 'paid' | 'status'>;

interface RentMatrixMonth {
  index: number;
  key: string;
  label: string;
  year: number;
  yearLabel: string;
}

interface RentMatrixRow {
  cells: RentMatrixCell[];
  id: string;
  rowTotal: number;
  title: string;
  creditLabel?: string;
  isDispute?: boolean;
  subtitle?: string;
}

interface RentMatrixGroupHeader {
  count: number;
  id: string;
  label: string;
}

interface RentMatrixLabels {
  dispute: string;
  footer: ReactNode;
  nameColumn: string;
  rowTotal: string;
}

interface RentMatrixLayout {
  cellHeight: number;
  columnWidth: number;
  contentWidth: number;
  footerHeight: number;
  headerHeight: number;
  nameWidth: number;
  rowHeight: number;
  showsFooter: boolean;
  showsRowTotal: boolean;
  totalWidth: number;
}

interface RentMatrixVisibleRange {
  endIndex: number;
  startIndex: number;
}

interface RentMatrixActiveCell {
  monthIndex: number;
  rowId: string;
}

interface RentCellPopoverAction {
  key: string;
  label: string;
  onClick: () => void;
  badge?: string;
  disabled?: boolean;
  icon?: ReactNode;
  loading?: boolean;
  variant?: ButtonVariant;
}

interface RentLegendEntry {
  label: string;
  description?: string;
}

export { RentCellTone, RentMatrixVariant };
export type {
  RentAriaSort,
  RentCellChange,
  RentCellPopoverAction,
  RentDensity,
  RentLegendEntry,
  RentMatrixActiveCell,
  RentMatrixCell,
  RentMatrixGroupHeader,
  RentMatrixLabels,
  RentMatrixLayout,
  RentMatrixMonth,
  RentMatrixRow,
  RentMatrixVisibleRange,
};
